<script lang="ts" setup>
/* Stores */
import { useBasketTimeStore } from '@/store/basket/basket-time'
import { useBasketStore } from '@/store/basket/basket'

/* Types */
import { DeliveryMethods } from '@/types/api/api-v3/basket'

const basketStore = useBasketStore()
const basketTime = useBasketTimeStore()

const timeHeadline = computed(() =>
  basketStore.data.delivery.method === DeliveryMethods.COURIER
    ? 'Доставим'
    : 'Будет готово',
)
</script>

<template>
  <div class="time-info">
    <div class="time-info__item">
      <div class="time-info__headline">
        <h3>{{ timeHeadline }}</h3>

        <h3>{{ basketTime.delivery_at_text }}</h3>
      </div>
    </div>

    <div class="time-info__item">
      <p>{{ basketTime.message }}</p>

      <nuxt-img
        src="/time-basket-icon.svg"
        alt="картинка"
        width="40"
        height="40"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.time-info {
  display: grid;
  gap: 10px;

  &__item {
    display: grid;
    grid-template-columns: 200px max-content;
    justify-content: space-between;

    h3 {
      font-size: 18px;
      font-weight: 800;
      color: $text-black;
    }

    p {
      margin: 0;
      font-size: 12px;
      font-weight: 600;
      color: $text-black;
    }
  }

  &__headline {
    line-height: 22px;
  }
}
</style>
